import { emitNarrationState } from "./narration-events";

const MAX_INTERRUPTED_TURNS = 256;
const interruptedScopes = new Set<string>();

type SpeechScope = { executionId?: string; ttsSource?: string };

function scopeKey(scope: SpeechScope): string | null {
  if (scope.executionId)
    return `execution:${encodeURIComponent(scope.executionId)}`;
  if (!scope.ttsSource?.startsWith("presentation:")) return null;
  const [, executionId, presentationId] = scope.ttsSource.split(":");
  return executionId
    ? `execution:${executionId}`
    : presentationId
      ? `presentation:${presentationId}`
      : null;
}

export function muteSpeechForUserTurn(scope: SpeechScope): void {
  const key = scopeKey(scope);
  if (!key) return;
  interruptedScopes.add(key);
  while (interruptedScopes.size > MAX_INTERRUPTED_TURNS) {
    interruptedScopes.delete(interruptedScopes.values().next().value!);
  }
}

/** Lets a muted turn speak again: it now answers what the user said next. */
export function unmuteSpeechForUserTurn(scope: SpeechScope): void {
  const key = scopeKey(scope);
  if (key) interruptedScopes.delete(key);
}

export function isSpeechMutedForUserTurn(scope: SpeechScope): boolean {
  const key = scopeKey(scope);
  return key !== null && interruptedScopes.has(key);
}

export function emitInterruptedPresentationSpeech(
  text: string,
  scope: SpeechScope,
): void {
  if (!scope.ttsSource?.startsWith("presentation:")) return;
  emitNarrationState({
    ...scope,
    utteranceId: `interrupted:${scope.ttsSource}`,
    text,
    provider: "denker",
    state: "cancelled",
    speechInterruptedByUser: true,
    at: Date.now(),
  });
}

export function resetUserSpeechInterruptionsForTests(): void {
  interruptedScopes.clear();
}
